var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8213 11.3965L31.6873 14.7125L24.3967 22.0031L31.6873 29.2937L31.8213 32.6097L28.5053 32.4757L21.2147 25.1851L13.9241 32.4757L10.6081 32.6097L10.7421 29.2937L18.0327 22.0031L10.7421 14.7125L10.6081 11.3965L13.9241 11.5305L21.2147 18.8211L28.5053 11.5305L31.8213 11.3965Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.f19a3d076d87d3f7a6c95c9e4b69e009.svg";
export { ForwardRef as ReactComponent };